var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkBox"},[_c('el-checkbox-group',{model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},_vm._l((_vm.options),function(v,i){return _c('el-checkbox',{key:i,attrs:{"label":i}},[_vm._v(_vm._s(v)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }